import { render, staticRenderFns } from "./policyGrid.vue?vue&type=template&id=437cfd2b"
import script from "./policyGrid.vue?vue&type=script&lang=js"
export * from "./policyGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports